export default __webpack_public_path__ + "static/media/icon-dashboard.e005a85f.svg";